import { Dialog } from "@mui/material";
import { IDataFormasRecebimento } from "../../../types/api/financeiro/pesquisar-formas-recebimento";
import { useState } from "react";

import DialogContentSelectGeneric from "../DialogsContents/DialogContentGeneric";
import MultipleChipsField from "../../BaseInputs/MultipleChipsField";

export default function SelectFormaRecebimentoMultiple({
    value,
    onChange,
    required = false,
    error = false,
    loja_id,
    flg_usa_receber = false,
    flg_pix_configurado = false,
    isDisabled = false
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    return (
        <>
            <MultipleChipsField
                value={value}
                label="Formas de recebimento"
                formatChipLabel={(item) => `${item.id} - ${item.nome}`}
                onClick={() => !isDisabled && setOpenModal(true)}
                error={!!error}
                helperText={error ? "Campo obrigatório" : isDisabled ? "Selecione uma loja primeiro" : ""}
                required={required}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        multiple
                        title="Selecionar formas de recebimento"
                        queryPath="/financeiro/contas-receber/pesquisar-formas-recebimento"
                        extraParams={{
                            limit: 50,
                            loja_id,
                            flg_usa_receber,
                            flg_pix_configurado
                        }}
                        getItemKey={(item) => item?.id ?? 0}
                        getItemLabel={(item) => item ? `${item.id} - ${item.nome}` : ''}
                        defaultValue={value ?? []}
                        onChange={(value) => {
                            onChange(value as IDataFormasRecebimento[])
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: IDataFormasRecebimento[] | null
    onChange: (arg: IDataFormasRecebimento[] | null) => void
    error?: boolean
    required?: boolean
    loja_id: number
    flg_usa_receber?: boolean
    flg_pix_configurado?: boolean
    isDisabled?: boolean
} 